import { render, staticRenderFns } from "./stockEditView.vue?vue&type=template&id=663f6953&scoped=true&"
import script from "./stockEditView.vue?vue&type=script&lang=js&"
export * from "./stockEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663f6953",
  null
  
)

export default component.exports